//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import vComponent from '@/core/vComponent'
import { getLocal } from '@/utils/globalState'
import { mapGetters } from 'vuex'
export default {
  name: 'TagBlock',
  extends: vComponent,
  data () {
    return {
      vipcode: null,
      items: [], // 使用者的tags
      labelH: [],
      labelI: [],
      isShowModal: false
    }
  },
  computed: {
    ...mapGetters([
      'theme'
    ]),
    allLabel () {
      const result = []
      this.labelH.forEach(itemH => {
        itemH.items = []
        this.labelI.forEach(itemI => {
          if (itemI.L_TYPE === itemH.L_TYPE) {
            itemH.items.push(itemI)
          }
        })
        result.push(itemH)
      })
      return result
    },
    // 以L_TYPE+L_NO組成key做比對
    itemKeys () {
      const keys = []
      this.items.forEach(item => {
        keys.push(`${item.L_TYPE}${item.L_NO}`)
      })
      return keys
    }
  },
  async created () {
    const currentVip = getLocal('currentVip')
    if (currentVip !== null && currentVip.VIP_CODE) this.vipcode = currentVip.VIP_CODE
    await this.getUserTag()
    await this.getLabelH()
    await this.getLabelI()
  },
  mounted () {
  },
  methods: {
    isActive (item) {
      return this.itemKeys.indexOf(item.L_TYPE + item.L_NO) !== -1
    },
    removeTag (currentItem) {
      if (this.vipcode === null) return
      let itemIndex = -1
      this.items.forEach((item, index) => {
        if (item.L_NO === currentItem.L_NO && item.L_TYPE === currentItem.L_TYPE) itemIndex = index
      })
      if (itemIndex !== -1) this.items.splice(itemIndex, 1)
    },
    modalClickItem (newItem) {
      console.log(`click item=`)
      console.log(newItem)
      let itemIndex = -1
      this.items.forEach((item, index) => {
        if (item.L_NO === newItem.L_NO && item.L_TYPE === newItem.L_TYPE) itemIndex = index
      })
      if (itemIndex === -1) {
        this.items.push(newItem)
      } else {
        this.items.splice(itemIndex, 1)
      }
    },
    async clickReset () {
      await this.getUserTag()
    },
    async clickSave () {
      await this.saveUserTag()
    },
    // ---- 取資料 ------
    // 取得可用tag類別
    async getLabelH () {
      const response = await this.fetch('label_H', this.vipcode)
      this.labelH = response.data !== null ? response.data : []
    },
    // 取得可用tag類別
    async getLabelI () {
      const response = await this.fetch('label_I', this.vipcode)
      this.labelI = response.data !== null ? response.data : []
    },
    async getUserTag () {
      if (this.vipcode === null) return
      const response = await this.fetch('vipLabel', this.vipcode)
      this.items = response.data !== null ? response.data : []
    },
    async saveUserTag () {
      if (this.vipcode === null) return
      const response = await this.fetch('vipLabelUpdate', this.vipcode, { data: this.items })
      return response
    }
  }
}
